import { tv } from '@/ui/utils'

/**
 * The brand's list item, as the join flow's studio list has it: a white square row, an
 * uppercase H7 label, a chevron. Rows sit 8px apart; the list, not the row, owns that gap.
 */
export const listRowStyles = tv({
	slots: {
		row: 'w-full min-h-12 rounded-brand bg-white px-4 py-3 flex-row items-center justify-between gap-3',
		body: 'flex-1 gap-1',
		label: 'font-display text-h7 uppercase text-ink',
		caption: 'font-body text-body2 text-muted',
	},
	variants: {
		tone: {
			white: {},
			ink: { row: 'bg-ink', label: 'text-white', caption: 'text-white' },
		},
	},
	defaultVariants: {
		tone: 'white',
	},
})
